import React from 'react'

export default function IconLpNavMenu({ color = '', style = {} }) {
    let fillColor = '#7246B1'
    if (color) fillColor = color
    let className = 'icons-icon'
    return (
        <svg
            className={className}
            style={style}
            xmlns='http://www.w3.org/2000/svg'
            viewBox='0 0 1000 1000'
            width='64'
            height='64'
            fill={fillColor}
        >
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M958 167H667 333 42C30 167 21 176 21 187V312C21 324 30 333 42 333H313V812C313 824 322 833 333 833H750C762 833 771 824 771 812V333H958C970 333 979 324 979 312V187C979 176 970 167 958 167ZM646 292H354V208H646V292ZM63 208H313V292H63V208ZM729 792H354V333H667 729V792ZM938 292H750 688V208H938V292ZM417 417C405 417 396 426 396 437S405 458 417 458H667C678 458 688 449 688 437S678 417 667 417H417ZM667 542H417C405 542 396 551 396 562S405 583 417 583H667C678 583 688 574 688 562S678 542 667 542ZM667 667H417C405 667 396 676 396 687S405 708 417 708H667C678 708 688 699 688 687S678 667 667 667Z'
            />
        </svg>
    )
}
